import { Permission } from 'api/planning';
import { RouteDefinition } from './types';
import { OrganisationStructureLevel } from 'const';

type Routes =
  | 'speakingSessions'
  | 'createSpeakingSession'
  | 'speakingSessionDetails'
  | 'addRoomToSpeakingSession'
  | 'editSpeakingSessionRoom'
  | 'releaseSpeakingSession'
  | 'editSpeakingSession'
  | 'removeSpeakingSession'
  | 'removeSpeakingSessionRoom'
  | 'manageSpeakingSessionRoomStructureExaminer';

export const getSpeakingRoutes: (basePath: string) => Record<Routes, RouteDefinition> = (
  basePath
) => ({
  speakingSessions: {
    path: '',
    absolutePath: basePath,
    requiresAny: [Permission.ViewPlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  createSpeakingSession: {
    path: 'create',
    absolutePath: `${basePath}/create`,
    requiresAny: [Permission.ManagePlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  speakingSessionDetails: {
    path: ':sessionId',
    absolutePath: `${basePath}/:sessionId`,
    requiresAny: [Permission.ViewPlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  addRoomToSpeakingSession: {
    path: 'add-room',
    absolutePath: `${basePath}/:sessionId/add-room`,
    requiresAny: [Permission.ManagePlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  editSpeakingSessionRoom: {
    path: 'edit-room',
    absolutePath: `${basePath}/:sessionId/edit-room`,
    requiresAny: [Permission.ManagePlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  releaseSpeakingSession: {
    path: 'release',
    absolutePath: `${basePath}/:sessionId/release`,
    requiresAny: [Permission.ManagePlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  editSpeakingSession: {
    path: 'edit',
    absolutePath: `${basePath}/:sessionId/edit`,
    requiresAny: [Permission.ManagePlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  removeSpeakingSession: {
    path: 'remove',
    absolutePath: `${basePath}/:sessionId/remove`,
    requiresAny: [Permission.ManagePlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  removeSpeakingSessionRoom: {
    path: 'room/:sessionRoomId/remove',
    absolutePath: `${basePath}/:sessionId/room/:sessionRoomId/remove`,
    requiresAny: [Permission.ManagePlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
  manageSpeakingSessionRoomStructureExaminer: {
    path: 'examiner-allocations',
    absolutePath: `${basePath}/:sessionId/examiner-allocations`,
    requiresAny: [Permission.ManagePlanningSession],
    filters: [{ required: OrganisationStructureLevel.Location }],
  },
});
